import React, { useState } from 'react';
import { usePortalInfos, useLanguage } from 'hooks';
import classNames from 'classnames';
import { useLocation } from 'react-router-dom';
import { CommonHeader, Cookies } from 'pages/shared';
import { COLOR, isDev, EN, ENG, FR, COLOR_CONTRAST_RATIO } from 'config/constants';
import { Box, Typography, Button } from '@material-ui/core';
import { images } from 'assets/images';
import { HvPleaseWait } from 'components';
import { LOADING } from 'state/constants';
import ChatBubbleRoundedIcon from '@material-ui/icons/ChatBubbleRounded';
import { makeStyles } from '@material-ui/core/styles';
import { getColorContrastRatio } from 'utils';
import {
  PortalHeader,
  Footer,
  NotFound as NotFoundContent,
} from 'pages/PersonalPortal/components/Public/components';
import { useIntl } from 'react-intl';

const useStyles = makeStyles({
  content: {
    minHeight: '100vh',
  },
  stickyHeader: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: 'auto',
    backgroundColor: COLOR.WHITE,
    zIndex: 999,
  },
  chatContent: {
    position: 'fixed',
    bottom: 50,
    right: 50,
    zIndex: 998,
    width: 60,
    height: 60,
    borderRadius: '50%',
    alignItems: 'center',
    justifyContent: 'center',
    display: 'flex',
    cursor: 'pointer',
    '@media (max-width: 768px)': {
      bottom: 20,
      right: 20,
    },
  },
  chatIcon: {
    fontSize: 30,
    color: COLOR.WHITE,
  },
  stickyFooter: {
    position: 'fixed',
    bottom: 0,
    width: '100%',
    height: 'auto',
    backgroundColor: COLOR.WHITE,
    zIndex: 999,
  },
});

function NotFound() {
  const classes = useStyles();
  const language = useLanguage();
  const isEn = language === ENG;
  const intl = useIntl();
  const location = useLocation();

  const dev_domain_name = new URLSearchParams(location.search).get('domain_name');

  const { sections, broker, broker_portal_infos, loading, favorite_listings, centris_listings } =
    usePortalInfos(null, isDev() ? dev_domain_name : window.location.hostname, isEn ? EN : FR);

  const primary_color = broker_portal_infos?.template_style?.primary_color || COLOR.WHITE;
  const secondary_color = broker_portal_infos?.template_style?.secondary_color || COLOR.BLACK;
  const secondary_color_contrast_ratio = getColorContrastRatio(secondary_color, COLOR.WHITE);
  const secondary_bg_text_color =
    secondary_color_contrast_ratio > COLOR_CONTRAST_RATIO ? COLOR.WHITE : COLOR.BLACK;

  const defaultHeaderContrastRatio = getColorContrastRatio(COLOR.ULTRA_DARK_BLUE, COLOR.WHITE);
  const [header_color_contrast_ratio, setHeaderColorContrastRatio] = useState(
    defaultHeaderContrastRatio,
  );

  const onClickChat = () => {
    if (isDev()) {
      window.location.href = `/contact?domain_name=${broker_portal_infos.domain_name}`;
    } else {
      window.location.href = '/contact';
    }
  };
  return (
    <div
      className={classes.content}
      style={{
        backgroundColor: primary_color,
        paddingTop: 100,
      }}
    >
      {loading === LOADING.STARTED ? (
        <HvPleaseWait color={secondary_color} className='transparent' />
      ) : null}
      {loading === LOADING.FINISHED && (
        <div style={{ backgroundColor: primary_color }}>
          <div className={classes.stickyHeader}>
            <PortalHeader
              logo_picture_url={broker_portal_infos.logo_image || broker.centrisCompanyLogoUrl}
              displaySocialMedia
              portal_infos={broker_portal_infos}
              broker={broker}
              sections={sections}
              favorite_listings={centris_listings}
              is_white_text={header_color_contrast_ratio > COLOR_CONTRAST_RATIO}
            />
          </div>
          <NotFoundContent broker_portal_infos={broker_portal_infos} />
          <Cookies
            is_white_text={header_color_contrast_ratio > COLOR_CONTRAST_RATIO}
            style={broker_portal_infos.template_style}
            secondary_bg_text_color={secondary_bg_text_color}
          />
          <Footer
            is_white_text={header_color_contrast_ratio > COLOR_CONTRAST_RATIO}
            style={broker_portal_infos.template_style}
            portal_infos={broker_portal_infos}
            broker={broker}
            sections={sections}
            favorite_listings={centris_listings}
          />

          {location.pathname !== '/contact' ? (
            <div
              className={classes.chatContent}
              onClick={onClickChat}
              style={{ backgroundColor: secondary_color }}
            >
              <ChatBubbleRoundedIcon className={classes.chatIcon} />
            </div>
          ) : null}
        </div>
      )}
    </div>
  );
}

export default NotFound;
